import { Component, Inject, OnInit, PLATFORM_ID, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs';
import { BaseComponent } from 'src/app/core/base-classes/base/base.component';
import { SSOLogin } from 'src/app/shared/models/auth/sso.login.model';
import { Company } from 'src/app/shared/models/company.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { ApiResponse } from 'src/app/shared/models/api.response';
import { isPlatformBrowser } from '@angular/common';
import { SnackbarService } from 'src/app/shared/services/snackBarService.service';
import { CompanyApiService } from 'src/app/company/services/company-api.service';

@Component({
    selector: 'app-okta',
    templateUrl: './okta.component.html',
    styleUrls: ['./okta.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OktaComponent extends BaseComponent implements OnInit {
  public ssoLogin: SSOLogin;
  public company: Company;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _globalService: GlobalService,
    private _authService: AuthService,
    private _snackbarService: SnackbarService,
    private _companyService: CompanyApiService,
    @Inject(PLATFORM_ID) private _platformId: unknown
  ) {
    super();
    this.ssoLogin = new SSOLogin();
    this.company = new Company();
  }

  ngOnInit(): void {
    const accessToken = this._activatedRoute.snapshot.fragment.split('&access_token=');
    const id_token = accessToken[0].replace('id_token=', '');
    const finalAccessToken = accessToken[1].split('&token_type')[0];

    this._globalService.setItem('id_token', id_token);
    this._globalService.setItem('access_token', finalAccessToken);

    if (isPlatformBrowser(this._platformId)) {
      const companyName = window.location.origin.split('.');
      this.company.companyName = companyName[0].split(':')[1].replace('//', '');
      this._companyService.companyDetail(this.company.companyName).pipe(takeUntil(this.destroy$)).subscribe((res) => {
        const companyRes = res as ApiResponse<Company>;
        this._globalService.setCompany('company', JSON.stringify(companyRes.data));

        this.ssoLogin.accessId = companyRes.data.accessId;
        this.ssoLogin.companyId = companyRes.data.id;
        this.ssoLogin.token = finalAccessToken;
        this._authService.oktaLogin(this.ssoLogin).pipe(takeUntil(this.destroy$)).subscribe((login: ApiResponse<SSOLogin>) => {
          if (login) {
            this._globalService.setUser('userData', JSON.stringify(login.data));
            this._snackbarService.open(login.message, 'Close', 'success');
            if (login.data.userType == 'Requestor')
              this._router.navigateByUrl('/access-request/submitted-requests');
            else
              this._router.navigateByUrl('/');
          }
        }, () => {
          this._router.navigateByUrl(`/company?error=${this._activatedRoute.snapshot.fragment['error']}`);
        });
      });
    }
  }
}
